import { createClient } from '@/shared/api';
import RESET_STUDY_MUTATION from '@/entities/study/api/mutations/resetStudy';
import type {
  ResetStudyMutation,
  ResetStudyMutationVariables,
} from '@/shared/api/generated/graphql';

export type ResetStudyResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the ResetStudyInput GraphQL input once its server-side shape is documented
/**
 * Resets a study so it can be processed again from scratch. Runs the resetStudy mutation and throws the server message on failure.
 *
 * @param input - Mutation input identifying the study to reset.
 * @returns A promise resolving to the resetStudy result.
 */
const handleResetStudy = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<ResetStudyMutation, ResetStudyMutationVariables>({
    mutation: RESET_STUDY_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { resetStudy } = data || {};
  if (!resetStudy.isSuccess) {
    throw new Error(resetStudy.message);
  }
  return resetStudy;
};

export default handleResetStudy;
